import { render, staticRenderFns } from "./preoperative.vue?vue&type=template&id=0be5f378&scoped=true&"
import script from "./preoperative.vue?vue&type=script&lang=js&"
export * from "./preoperative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be5f378",
  null
  
)

export default component.exports